export const columnsEndOfDayComparison = [
  {
    Header: "BRANCH ID",
    accessor: "branch_id",
  },
  {
    Header: "ORDER DATE",
    accessor: "order_date",
  },
  {
    Header: "STATUS DATA OK",
  },
  {
    Header: "TOTAL SALES RAW",
    accessor: "total_sales_raw",
  },
  {
    Header: "COUNT BILL RAW",
    accessor: "count_bill_raw",
  },
  {
    Header: "TOTAL SALES OK",
    accessor: "total_sales_ok",
  },
  {
    Header: "COUNT BILL OK",
    accessor: "count_bill_ok",
  },
  {
    Header: "TOTAL CANCEL BILL",
    accessor: "total_sales_cancel_bill",
  },
  {
    Header: "COUNT CANCEL BILL",
    accessor: "count_bill_cancel_bill",
  },
  {
    Header: "TOTAL CANCEL ITEM",
    accessor: "total_sales_cancel_item",
  },
  {
    Header: "COUNT CANCEL ITEM",
    accessor: "count_bill_cancel_item",
  },
  {
    Header: "TOTAL SALES CXM",
    accessor: "total_sales_cxm",
  },
  {
    Header: "COUNT BILL CXM",
    accessor: "count_bill_cxm",
  },
];
